import type { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedProps {
  children: ReactNode;
}

export function Protected({ children }: Readonly<ProtectedProps>): ReactNode {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    return (
      <Navigate
        to={'/login'}
        state={{
          hash: location.hash,
          pathname: location.pathname,
          search: location.search
        }}
        replace={true}
      />
    );
  }

  return children;
}
